import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames/bind';
import Button from 'yoda-core-components/lib/components/Button';
import {
    URL_CHECKOUT_PAYMENT,
    URL_CHECKOUT_SHIPPING,
    URL_CHECKOUT_BOPIS,
} from 'yoda-checkout-components/lib/common/Constants';
import {
    AMR_CO_EDIT_SHIPPING,
    AMR_CO_EDIT_PAYMENT,
    AMR_CO_EDIT_BOPIS,
} from 'yoda-checkout-components/lib/common/AmrConstants';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as styles from './NewCheckoutHeader.css';

const cx = classnames.bind(styles);
export function NewCheckoutHeader(props) {
    let path = '';
    let amrCodeId = '';
    if (props.title === 'Shipping') {
        path = URL_CHECKOUT_SHIPPING;
        amrCodeId = AMR_CO_EDIT_SHIPPING;
    } else if (props.title === 'Payment') {
        path = URL_CHECKOUT_PAYMENT;
        amrCodeId = AMR_CO_EDIT_PAYMENT;
    } else {
        path = URL_CHECKOUT_BOPIS;
        amrCodeId = AMR_CO_EDIT_BOPIS;
    }
    function onEdit() {
        props.editAction(path);
    }
    const { active, showEdit, index, title } = props;
    const automationId = {
        index: `accordion-${title}-panel-no`,
        title: `accordion-${title}-panel-title`,
        edit: `accordion-${title}-panel-edit-button`,
    };
    return (
        <div
            id={amrCodeId}
            className={cx(
                'accordionSection',
                active ? 'accordionSectionActive' : '',
                showEdit ? dt(['!text-black']) : dt(['flex', 'justify-between'])
            )}
        >
            <div className={`${cx('accordionContent')} ${dt(['flex', 'justify-between'])}`}>
                <p className={dt(['flex', 'items-center'])}>
                    <span className={cx('accordionNumber')} data-automation-id={automationId.index}>
                        {index}.
                    </span>
                    <span
                        className={`${cx('accordionText')} ${dt(['pl-1.5'])}`}
                        data-automation-id={automationId.title}
                    >
                        {title}
                    </span>
                </p>
                {showEdit && (
                    <Button
                        automationId={automationId.edit}
                        type="button"
                        size="Sm"
                        onClick={onEdit}
                        buttonType="Secondary"
                        className={`${cx('accordionBtn')} ${dt([
                            'h-8',
                            '!min-w-[50px]',
                            '!max-w-[50px]',
                            '!p-0',
                            'float-right',
                            'font-normal',
                        ])}`}
                    >
                        Edit
                    </Button>
                )}
            </div>
        </div>
    );
}

NewCheckoutHeader.propTypes = {
    active: PropTypes.bool,
    showEdit: PropTypes.bool,
    index: PropTypes.string,
    title: PropTypes.string,
    editAction: PropTypes.func.isRequired,
};
NewCheckoutHeader.defaultProps = {
    active: false,
    showEdit: false,
    index: '',
    title: '',
};

export default NewCheckoutHeader;
